import { mapState } from "pinia";
import { EventCountdownElementMixin } from "%/dynamic-component-editor/standard-components/event-card/event-countdown-element-mixin";
import { EVENT_PREVIEW_STATE_LIVE } from "%/dynamic-component-editor/options/event-preview-state";
import { EVENT_TYPE_LIVESTREAM } from "%/constants/event-constants";
import { useVideoCallStore } from "%/apps/video-engine/stores/video-call-store";
import {
  subscribeToEventPresence,
  unsubscribeFromEventPresence,
} from "%/dynamic-component-editor/helpers/event-presence-poller";

const EXAMPLE_LIVE_PRESENCE = Object.freeze({ participants: 12, publishers: 1, viewers: 11 });
const EMPTY_PRESENCE = Object.freeze({ participants: 0, publishers: 0, viewers: 0 });

export function eventIdFromLocation(pathname) {
  const [, id] = String(pathname || "").match(/\/event\/(\d+)/) || [];

  return Number(id || 0);
}

export const EventPresenceElementMixin = {
  extends: EventCountdownElementMixin,
  computed: {
    ...mapState(useVideoCallStore, ["presenceByEventId"]),
    isLivestreamEvent() {
      return this.entity?.eventType === EVENT_TYPE_LIVESTREAM;
    },
    readsLivePresence() {
      return !this.editMode && typeof window !== "undefined";
    },
    presenceEventId() {
      if (!this.readsLivePresence) {
        return 0;
      }
      const fromUrl = eventIdFromLocation(window.location.pathname);
      if (fromUrl) {
        return fromUrl;
      }

      return Number(this.entity?.eventId || this.entity?.id || 0);
    },
    eventPresence() {
      if (this.readsLivePresence) {
        return this.presenceByEventId[this.presenceEventId] || EMPTY_PRESENCE;
      }

      return this.eventPreviewState === EVENT_PREVIEW_STATE_LIVE ? EXAMPLE_LIVE_PRESENCE : EMPTY_PRESENCE;
    },
  },
  watch: {
    presenceEventId: {
      immediate: true,
      handler(eventId, previousEventId) {
        if (previousEventId) {
          unsubscribeFromEventPresence(previousEventId, this);
        }
        if (eventId) {
          subscribeToEventPresence(eventId, this);
        }
      },
    },
  },
  beforeUnmount() {
    if (this.presenceEventId) {
      unsubscribeFromEventPresence(this.presenceEventId, this);
    }
  },
};
